import { DateTime } from 'luxon'

import { isAwaitingWithdrawal } from './allowance'

// Prioridade de exibição na lista de resgates de um item (menor = topo):
// 0 aguardando retirada (approved) — acionável, sobe
// 1 retirado (delivered)
// 2 reembolsado (canceled)
// 3 expirado (status `expired`, dito pela api) — desce pro fim
const groupRank = request => {
  const { status } = request
  if (isAwaitingWithdrawal(request)) return 0
  if (status === 'delivered') return 1
  if (status === 'canceled') return 2
  if (status === 'expired') return 3
  return 4
}

// Recência: created_at quando disponível, senão id incremental como proxy.
const recency = (request) => {
  if (request.created_at) return DateTime.fromISO(request.created_at).toMillis()
  return request.id ?? 0
}

// Ordena por grupo de prioridade e, dentro do grupo, do mais recente ao mais
// antigo — um novo resgate aparece no topo, não escondido no fim da lista.
export const sortRewardRequests = (rewardRequests = []) =>
  [...rewardRequests].sort((a, b) => {
    const rankDiff = groupRank(a) - groupRank(b)
    if (rankDiff !== 0) return rankDiff
    return recency(b) - recency(a)
  })
